<div class="mt-3 wrapper position-relative" *ngIf="salesAccelerators && salesAccelerators.length > 0">
  <div class="row mx-2" appScrollableXBox #list="appScrollableXBox">
    <div class="col-12 col-md-8 col-lg-5 d-flex mb-1" *ngFor="let item of salesAccelerators">
      <app-sales-accelerator-item [item]="item"></app-sales-accelerator-item>
    </div>
  </div>
  <div class="position-absolute left-scroll-btn" *ngIf="list.canScrollStart$ | async">
    <button class="btn" type="button" (click)="list.scroll('backward')">
      <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
    </button>
  </div>
  <div class="position-absolute right-scroll-btn" *ngIf="list.canScrollEnd$ | async">
    <button class="btn" type="button" (click)="list.scroll('forward')">
      <fa-icon [size]="'lg'" [icon]="['fas', 'chevron-right']"></fa-icon>
    </button>
  </div>
</div>
